
import { ModalContent } from '@/components/ModalContent'

export function Register() {
  return (
    <div className="flex items-center justify-center py-12">
      <ModalContent isRegisterPage={true} />
    </div>
  )
}